import { render } from "./CheckoutPromoRow.vue?vue&type=template&id=25437384"
import script from "./CheckoutPromoRow.vue?vue&type=script&lang=js"
export * from "./CheckoutPromoRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__